<div *ngIf="sections">
  <div *ngFor="let section of sections" (click)="selectSection(section)">
    <span>{{ section.name }}</span>
  </div>
</div>
